export default __webpack_public_path__ + "static/media/video-2.357966c9.mp4";